
/*
 *   File : update-basket-allocations.js
 *   Author URI : https://evoqins.com
 *   Description : The modal component used for adding funds.
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";

// Custom components
import { Icon } from "../Icon";
import { CustomTextInput1, SearchInput } from "../FormElements";
import { PrimaryButton, SecondaryButton } from "../Buttons";

// Custom styles
import style from "../../Styles/Components/add-fund.module.scss";

// Services
import APIService from "../../Services/api-service";

import SearchFund from "../../Assets/Images/Funds/search.png"


const UpdateAllocation = (props) => {
    const [selectedFunds, setSelectedFunds] = useState([]);
    const [apiLoader, setApiLoader] = useState(false);
    const [fundAdded, setFundAdded] = useState(false);
    const [loader, setLoader] = useState(false);
    const [fundList, setFundList] = useState([]);
    const [search, setSearch] = useState("");
    const [showList, setShowList] = useState(false);
    const [deleteIds, setDeleteIds] = useState([]);

    useEffect(() => {
        var my_modal = document.getElementById("update-allocation");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.closeModal();
        });
        //eslint-disable-next-line
    }, [props.closeModal]);

    useEffect(() => {
        if (props.data !== null) {
            setFundAdded(true);
            let selected_funds = []
            props.data.map((item) => (
                //eslint-disable-next-line

                selected_funds.push({
                    alias: item.fund_alias,
                    scheme_name: item.fund_name,
                    error: "",
                    error1: "",
                    ...item
                })
            ))
            setSelectedFunds(selected_funds);
        }
        //eslint-disable-next-line
    }, [props.data])

    function _handleAllocation(input_value, index) {
        const selected = [...selectedFunds]
        selected[index]['allocation'] = input_value > 100 ? 100 : input_value;
        selected[index]['error'] = ""
        setSelectedFunds(selected)
    }

    function _handleAlias(input_value, index) {
        const selected = [...selectedFunds]
        selected[index]['alias'] = input_value;
        selected[index]['error1'] = ""
        setSelectedFunds(selected)
    }

    // Delete funds
    function _handleDelete(index, allocation_id) {
        let selected_funds = [...selectedFunds]
        let delete_ids = [...deleteIds]
        const delete_index = delete_ids.findIndex((item) => item === allocation_id)
        if (delete_index === -1) {
            delete_ids.push(allocation_id)
        } else {
            delete_ids.splice(delete_index, 1)
        }
        selected_funds.splice(index, 1);
        setSelectedFunds(selected_funds);
        setDeleteIds(delete_ids)
    }

    function _handleFunds(data) {
        let funds = [...selectedFunds]
        const index = funds.findIndex((item) => item.scheme_code === data.scheme_code)
        if (index === -1) {
            funds.push({
                ...data,
                allocation: "",
                alias: "",
                error: "",
                error1: ""
            });

        } else {
            funds.splice(index, 1)
        }
        setSelectedFunds(funds)
    }

    function _handleSearch(search_value) {
        setSearch(search_value);
        if (search_value === "") {
            _getFunds("");
        }
    }
    const _handleUpdate = () => {
        let valid = true;
        const selected_funds = [...selectedFunds]
        for (let i = 0; i < selected_funds.length; i++) {
            if (selected_funds[i].allocation === "") {
                selected_funds[i].error = "Allocation is required";
                valid = false
            }

            if (selected_funds[i].alias === "") {
                selected_funds[i].error1 = "Fund alias is required";
                valid = false
            }
        }
        setSelectedFunds(selected_funds)
        if (valid === true) {
            if (props.data !== null) {
                _deleteFunds();
            } else {
                _addFund();
            }
        }
    }

    const _addFund = () => {
        setApiLoader(true);
        const funds = selectedFunds.map((item) => {
            return ({
                "asset_class": item.asset_class,
                "scheme_code": item.scheme_code,
                "allocation": item.allocation,
                "fund_alias": item.alias,

            })
        })
        const url = "/baskets/update";
        const request = {
            "basket_id": props.basketId,
            "funds": funds
        }

        APIService(true, url, request).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                toast.success(props.data === null ? "Funds added to basket successfully" : "Basket updated successfully", {
                    type: "success"
                });
                props.updateList();
                document.getElementById("close-modal").dispatchEvent(new Event("click"));
            } else {
                toast.error(response.message, {
                    type: "error"
                });
            }
            setApiLoader(false);
        })
    }

    //API- delete fund
    const _deleteFunds = () => {
        setApiLoader(true);
        const url = "/fund/delete";
        const request = {
            allocation_ids: deleteIds
        }
        APIService(true, url, request).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                _addFund();
            } else {
                toast.error(response.message, {
                    type: 'error'
                });
            }
        });
    }

    // search funds
    const _getFunds = (query) => {
        setLoader(true);
        const url = "/fund/search";
        const request = {
            "query": query,
            "page_num": 1
        }

        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setFundList(response.data);
                setShowList(true)
            } else {
                setFundList([]);
            }
            setLoader(false);
        })
    }

    return (
        <div className={`modal fade ${style.e_add_fund}`}
            id="update-allocation"
            tabIndex="-1"
            aria-labelledby="update-allocation"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content padding-32px-all ${style.e_content} `}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="e-font-16 e-line-height-24 e-montserrat-semi-bold color-dark-charcoal mb-0">
                            Manage Funds
                        </h5>
                        <Icon icon="close"
                            size={18}
                            id="close-modal"
                            data-bs-dismiss="modal"
                            className='cursor-pointer' />
                    </div>
                    {fundAdded === true ?
                        <div className={`${style.e_wrapper} pt-5`}>
                            <div className="row pb-3">
                                <div className="col-5">
                                    <h6 className="e-montserrat-semi-bold e-font-14 e-line-height-20 color-dark-charcoal">Fund</h6>
                                </div>
                                <div className="col-3">
                                    <h6 className="e-montserrat-semi-bold e-font-14 e-line-height-20 color-dark-charcoal">Fund alias</h6>
                                </div>
                                <div className="col-3">
                                    <h6 className="e-montserrat-semi-bold e-font-14 e-line-height-20 color-dark-charcoal">Allocation(%)</h6>
                                </div>
                            </div>
                            {
                                selectedFunds.map((item, index) => {
                                    return (
                                        <div className="row pb-4 align-items-center">
                                            <div className="col-5">
                                                <span className="e-montserrat-medium e-font-14 e-line-height-20 color-dark-charcoal">{item.scheme_name}</span>
                                            </div>
                                            <div className="col-3">
                                                <CustomTextInput1 value={item.alias}
                                                    label="Fund Alias"
                                                    placeHolder="Fund Alias"
                                                    postfix="*"
                                                    error={item.error1}
                                                    handleChange={(input_value) => _handleAlias(input_value, index)} />
                                            </div>
                                            <div className="col-3">
                                                <CustomTextInput1 value={item.allocation}
                                                    label="Allocation"
                                                    placeHolder="Allocation"
                                                    postfix="*"
                                                    type="number"
                                                    error={item.error}
                                                    handleChange={(input_value) => _handleAllocation(input_value, index)} />
                                            </div>
                                            <div className="col-1 px-0">
                                                <Icon icon="delete"
                                                    size={24}
                                                    className="cursor-pointer e-delete-hover"
                                                    onClick={() => _handleDelete(index, item.id)} />
                                            </div>

                                        </div>
                                    )
                                })
                            }
                        </div>
                        :
                        <Fragment>
                            <div className="col-12 pb-3 padding-32px-top">
                                <SearchInput className={`${style.e_search_input} py-2`}
                                    value={search}
                                    valueChange={_handleSearch}
                                    clear={() => {
                                        setSearch("");
                                        _getFunds("");

                                    }}
                                    handleSearch={() => _getFunds(search === "" ? null : search)} />

                            </div>
                            {
                                loader === true ?
                                    <div className={`${style.e_wrapper} d-flex align-items-center`}>
                                        <img src={require("../../Assets/Images/Loader/page-loader.gif")}
                                            alt={"loader"}
                                            width={60}
                                            height={60}
                                            className="mx-auto" />
                                    </div>
                                    :
                                    showList === true ?
                                        fundList.length === 0 ?
                                            <div className={`${style.e_wrapper} d-flex align-items-center`}>
                                                <div className="col-12 text-center">
                                                    <img src={SearchFund}
                                                        alt="search"
                                                        draggable={false}
                                                        width={160}
                                                        height={160}
                                                        className="my-auto mx-auto" />
                                                    <p className="mb-0 mt-3 color-silver-gray text-center e-font-14 e-line-height-18 e-montserrat-medium">Search for funds , No funds found</p>
                                                </div>
                                            </div>
                                            :
                                            <div className={`${style.e_wrapper}`}>
                                                <div className="row">
                                                    {

                                                        fundList.map((item) => {
                                                            return (

                                                                <div className="col-sm-6 pb-4">
                                                                    <div className="d-flex  align-items-start gap-8px cursor-pointer" onClick={() => _handleFunds(item)} >
                                                                        <span>
                                                                            <Icon icon={selectedFunds.some((data) => data.scheme_code === item.scheme_code) ? "checked" : "unchecked"} size={20}
                                                                                className="cursor-pointer"
                                                                            />
                                                                        </span>
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="e-montserrat-medium e-font-14 e-line-height-20 color-dark-charcoal">{item.scheme_name}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )
                                                        })}
                                                </div>
                                            </div>
                                        :
                                        <div className={`${style.e_wrapper} d-flex align-items-center`}>
                                            <div className="col-12 text-center">
                                                <img src={SearchFund}
                                                    alt="search"
                                                    draggable={false}
                                                    width={160}
                                                    height={160}
                                                    className="my-auto mx-auto" />
                                                <p className="mb-0 mt-3 color-silver-gray text-center e-font-14 e-line-height-18 e-montserrat-medium">Search for funds </p>
                                            </div>
                                        </div>
                            }
                        </Fragment>
                    }
                    <div className="d-flex justify-content-end pt-3">
                        <div className="d-flex gap-8px justify-content-end">
                            {props.data === null && <SecondaryButton label={fundAdded === true ? "Back" : "Cancel"}
                                cancel={fundAdded === false && "modal"}
                                className="padding-14px-tb padding-50px-lr"
                                handleClick={() => fundAdded === true && setFundAdded(false)} />}
                            <PrimaryButton label={"Update"}
                                className="padding-14px-tb padding-60px-lr"
                                handleClick={() => fundAdded === true ? _handleUpdate() : setFundAdded(true)}
                                loader={apiLoader}
                                disabled={selectedFunds.length === 0 ? true : apiLoader} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateAllocation